import type { ReactNode } from 'react'
import { useI18n } from '../i18n/useI18n'
import type { StringKey } from '../i18n/strings'

export type Route = '/' | '/loyers' | '/depenses' | '/immeuble' | '/plus'

interface Tab {
  route: Route
  label: StringKey
  icon: ReactNode
}

// Icones dessinees a la main plutot qu'une bibliotheque : quelques
// octets au lieu de quelques dizaines de kilo-octets a telecharger sur
// la connexion de Mbour.
const tabs: Tab[] = [
  {
    route: '/',
    label: 'nav_home',
    icon: (
      <path d="M3 10.5 12 3l9 7.5M5.5 9.5V20h13V9.5" />
    ),
  },
  {
    route: '/loyers',
    label: 'nav_rent',
    icon: (
      <>
        <path d="M3 7h18v11H3z" />
        <circle cx="12" cy="12.5" r="2.5" />
      </>
    ),
  },
  {
    route: '/depenses',
    label: 'nav_expenses',
    icon: (
      <>
        <path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" />
        <path d="M9 8h6M9 12h6" />
      </>
    ),
  },
  {
    route: '/immeuble',
    label: 'nav_building',
    icon: (
      <>
        <path d="M5 21V4h14v17" />
        <path d="M9 8h2M13 8h2M9 12h2M13 12h2M9 16h2M13 16h2" />
      </>
    ),
  },
  {
    route: '/plus',
    label: 'nav_more',
    icon: (
      <>
        <circle cx="5" cy="12" r="1.6" />
        <circle cx="12" cy="12" r="1.6" />
        <circle cx="19" cy="12" r="1.6" />
      </>
    ),
  },
]

export function BottomNav({
  current,
  onNavigate,
}: {
  current: Route
  onNavigate: (route: Route) => void
}) {
  const { t } = useI18n()

  return (
    <nav className="bottomnav" aria-label={t('app_name')}>
      {tabs.map((tab) => {
        const active = tab.route === current
        return (
          <button
            key={tab.route}
            type="button"
            className={`bottomnav__tab ${active ? 'is-active' : ''}`}
            aria-current={active ? 'page' : undefined}
            onClick={() => onNavigate(tab.route)}
          >
            <svg
              className="bottomnav__icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              {tab.icon}
            </svg>
            <span className="bottomnav__label">{t(tab.label)}</span>
          </button>
        )
      })}
    </nav>
  )
}
